import { useSyncExternalStore } from 'react';

/**
 * O relógio, lido do jeito que o React quer que se leia.
 *
 * ---
 *
 * POR QUE NÃO `Date.now()` DIRETO NO RENDER
 *
 * O tempo é um estado EXTERNO que muda sozinho. Lê-lo no corpo do componente
 * torna o render impuro: duas execuções com as mesmas props produzem telas
 * diferentes, e o React tem toda liberdade de renderizar de novo quando bem
 * entender.
 *
 * Na prática, isso aparece assim: um horário cujo prazo de cancelamento vence
 * enquanto a tela está aberta continua mostrando o botão — porque nada disse ao
 * React que aquele valor mudou. Com `useSyncExternalStore`, a passagem do tempo
 * é uma assinatura como qualquer outra, e o botão some sozinho na virada.
 */
export function useNow(intervalMs = 30_000): number {
  return useSyncExternalStore(
    (onChange) => {
      const timer = setInterval(onChange, intervalMs);
      return () => clearInterval(timer);
    },
    () => {
      // Arredondar para o intervalo evita um snapshot novo a cada leitura — o
      // React compara o valor, e um número sempre diferente causaria render
      // infinito.
      const agora = Date.now();
      return agora - (agora % intervalMs);
    },
    // No servidor não há relógio que mude: um valor fixo basta, e a hidratação
    // corrige na primeira assinatura.
    () => 0,
  );
}
